/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section3list_Purpose2Inputs */

const id_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuan dan Karakter Penggunaan:`)
};

const ms_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuan dan Sifat Penggunaan:`)
};

const da_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formål og Karakter af Brug:`)
};

const de_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweck und Art der Nutzung:`)
};

const en_us2_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purpose and Character of Use:`)
};

const es_es2_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propósito y carácter del uso:`)
};

const es_mx2_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propósito y carácter del uso:`)
};

const fil_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layunin at Katangian ng Paggamit:`)
};

const fr_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`But et nature de l'utilisation :`)
};

const it_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopo e carattere dell'uso:`)
};

const hu_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A használat célja és jellege:`)
};

const nl_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doel en karakter van het gebruik:`)
};

const no_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formål og karakter av bruk:`)
};

const pl_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel i charakter użycia:`)
};

const pt_br2_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalidade e caráter de uso:`)
};

const pt_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalidade e caráter do uso:`)
};

const ro_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopul și caracterul utilizării:`)
};

const fi_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytön tarkoitus ja luonne:`)
};

const sv_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändamål och karaktär av användning:`)
};

const vi_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục đích và tính chất sử dụng:`)
};

const tr_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanımın Amacı ve Niteliği:`)
};

const cs_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účel a povaha použití:`)
};

const bg_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цел и характер на употребата:`)
};

const ru_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цель и характер использования:`)
};

const uk_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мета та характер використання:`)
};

const ar_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الغرض وطبيعة الاستخدام:`)
};

const hi_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उद्देश्य और चरित्र:`)
};

const th_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วัตถุประสงค์และลักษณะการใช้งาน:`)
};

const ja_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用の目的と性質：`)
};

const zh_cn2_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的目的和性质：`)
};

const zh_hant1_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的目的和性質：`)
};

const ko_misc_fairuse_section3list_purpose2 = /** @type {(inputs: Misc_Fairuse_Section3list_Purpose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용의 목적과 성격:`)
};

/**
* | output |
* | --- |
* | "Purpose and Character of Use:" |
*
* @param {Misc_Fairuse_Section3list_Purpose2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section3list_purpose2 = /** @type {((inputs?: Misc_Fairuse_Section3list_Purpose2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section3list_Purpose2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "da") return da_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "de") return de_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "it") return it_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "no") return no_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "th") return th_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section3list_purpose2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section3list_purpose2(inputs)
	return ko_misc_fairuse_section3list_purpose2(inputs)
});
export { misc_fairuse_section3list_purpose2 as "misc.fairUse.section3List.purpose" }